

export const columns = function (date) {
    return [{
        name: "",
        key: "name",
        type: "text"
    },
    {
        name: "Available Rooms",
        children: [{
            name: `Actual ${date - 2}`,
            type: "number",
            key: "availableActual"
        }, {
            name: `Budget ${date - 1}`,
            type: "number",
            key: "availableYearBudget"
        }, {
            name: `Act+ Fcst ${date - 1}`,
            type: "number",
            key: "availableFcst"
        }, {
            name: `Budget ${date}`,
            type: "number",
            key: "availableBudget"
        }]
    },
    {
        name: "Rooms Sold",
        children: [{
            name: `Actual ${date - 2}`,
            type: "number",
            key: "roomsActual"
        }, {
            name: `Budget ${date - 1}`,
            type: "number",
            key: "roomsYearBudget"
        }, {
            name: `Act+ Fcst ${date - 1}`,
            type: "number",
            key: "roomsFcst"
        }, {
            name: `Budget ${date}`,
            type: "number",
            key: "roomsBudget"
        }]
    },
    {
        name: "Occupancy %",
        children: [{
            name: `Actual ${date - 2}`,
            type: "percent",
            key: "occActual"
        }, {
            name: `Budget ${date - 1}`,
            type: "percent",
            key: "occYearBudget"
        }, {
            name: `Act+ Fcst ${date - 1}`,
            type: "percent",
            key: "occFcst"
        }, {
            name: `Budget ${date}`,
            type: "percent",
            key: "occBudget"
        }, {
            name: `Variance`,
            type: "percent",
            key: "occVar"
        }, {
            name: ` Percent Change`,
            type: "percent",
            key: "occPercent"
        }]
    },
    {
        name: "Average Room Rate",
        children: [{
            name: `Actual ${date - 2}`,
            type: "number",
            key: "arrActual"
        }, {
            name: `Budget ${date - 1}`,
            type: "number",
            key: "arrYearBudget"
        }, {
            name: `Act+ Fcst ${date - 1}`,
            type: "number",
            key: "arrFcst"
        }, {
            name: `Budget ${date}`,
            type: "number",
            key: "arrBudget"
        }, {
            name: `Variance`,
            type: "number",
            key: "arrVar"
        }, {
            name: ` Percent Change`,
            type: "percent",
            key: "arrPercent"
        }]
    },
    {
        name: "Revenue Per Available Room",
        children: [{
            name: `Actual ${date - 2}`,
            type: "number",
            key: "rparActual"
        }, {
            name: `Budget ${date - 1}`,
            type: "number",
            key: "rparYearBudget"
        }, {
            name: `Act+ Fcst ${date - 1}`,
            type: "number",
            key: "rparFcst"
        }, {
            name: `Budget ${date}`,
            type: "number",
            key: "rparBudget"
        }, {
            name: `Variance`,
            type: "number",
            key: "rparVar"
        }, {
            name: ` Percent Change`,
            type: "percent",
            key: "rparPercent"
        }]
    },
    {
        name: "Room Revenue",
        children: [{
            name: `Actual ${date - 2}`,
            type: "number",
            key: "revActual"
        }, {
            name: `Budget ${date - 1}`,
            type: "number",
            key: "revYearBudget"
        }, {
            name: `Act+ Fcst ${date - 1}`,
            type: "number",
            key: "revFcst"
        }, {
            name: `Budget ${date}`,
            type: "number",
            key: "revBudget"
        }, {
            name: `Variance`,
            type: "number",
            key: "revVar"
        }, {
            name: ` Percent Change`,
            type: "percent",
            key: "revPercent"
        }]
    }
    ]
};



export const columnsColumn = [{
    name: "酒店名称",
    key: "name",
    type: "text"
},
{
    name: "",
    key: "typename",
    type: "text"
},
{
    name: "R/Nts",
    key: "rn",
    type: "number"
},
{
    name: "A.R.R",
    key: "arr",
    type: "number"
},
{
    name: "Revenue",
    key: "rev",
    type: "number"
},
{
    name: "Occ %",
    key: "occ",
    type: "percent"
},
{
    name: "RevPAR",
    key: "revpar",
    type: "number"
},
{
    name: "Avai Rm",
    key: "ava",
    type: "number"
},
]

export const listName = [["availableActual", "availableYearBudget", "availableFcst", "availableBudget"], ["roomsActual", "roomsYearBudget", "roomsFcst", "roomsBudget"], ["occActual", "occYearBudget", "occFcst", "occBudget", "occVar", "occPercent"], ["arrActual", "arrYearBudget", "arrFcst", "arrBudget", "arrVar", "arrPercent"], ["rparActual", "rparYearBudget", "rparFcst", "rparBudget", "rparVar", "rparPercent"], ["revActual", "revYearBudget", "revFcst", "revBudget", "revVar", "revPercent"]]


// WEBPACK FOOTER //
// ./src/components/otherHeadquartersForms/BPBudgetSummary/data.js